//Added by - jhamman lal sahu on 18-08-2024
//Reason - to add top to page button

import React, { useState, useEffect } from "react";
import TopToPageStyle from "./TopToPage.module.css";
import { IoChevronUpSharp } from "react-icons/io5";

const TopToPage = () => {
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    if (window.scrollY > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  //Added by - jhamman lal sahu on 18-08-2024
  //Reason - To scroll on the top of page

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  //Added by - jhamman lal sahu on 18-08-2024
  //Reason - To scroll on the top of page

  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);
    return () => {
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, []);

  return (
    <div>
      {isVisible && (
        <div className={TopToPageStyle.mainContainer} onClick={scrollToTop}>
          <IoChevronUpSharp className={TopToPageStyle.icon} />
        </div>
      )}
    </div>
  );
};

export default TopToPage;

//Added by - jhamman lal sahu on 18-08-2024
//Reason - to add top to page button
